const PresentationChartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99996 13.3333V17.5M9.99996 13.3333L15 17.5M9.99996 13.3333L4.99996 17.5M17.5 2.5V9.33333C17.5 10.7335 17.5 11.4335 17.2275 11.9683C16.9878 12.4387 16.6053 12.8212 16.1349 13.0608C15.6002 13.3333 14.9001 13.3333 13.5 13.3333H6.49996C5.09983 13.3333 4.39976 13.3333 3.86498 13.0608C3.39458 12.8212 3.01213 12.4387 2.77244 11.9683C2.49996 11.4335 2.49996 10.7335 2.49996 9.33333V2.5M6.66663 7.5V10M9.99996 5.83333V10M13.3333 9.16667V10M18.3333 2.5H1.66663"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PresentationChartIcon;
